<template>
  <div :class="['tips-main']">
    <div class="tips-box-fa">
      <img class="pg1" src="@/assets/image/manualReview/pg1.png" />
      <div class="tips-box">
        <div class="pg2-box">
          <img class="pg2" src="@/assets/image/manualReview/pg2.png" />
          兑换成功！
        </div>

        <div class="text-box">
          由于您的信用值低于100，等待人工审核订单后，在兑换历史中领取！
        </div>

        <div class="btn-box" @click="submit">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["url", "name"],
  data() {
    return {
      time: null,
      timeNumber: 10,
      agree: false,
      imgshow: false,
      img: null,
      isFlag: false,
      page: 1,
      idCard: "",
      phoneNumber: ""
    };
  },
  methods: {
    ...mapActions(["setAccount"]),

    submit() {
      this.$emit("submit");
    }
  },

  created() {}
};
</script>
<style lang="scss" scoped>
.tips-main {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .tips-box-fa {
    background-color: #fff;
    width: 281px;
    height: 300px;
    position: relative;
    border-radius: 12px 12px 12px 12px;
    .pg1 {
      width: 208px;
      height: 128px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -100px;
      z-index: 2;
    }
  }
  .tips-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 281px;
    height: 300px;
    z-index: 1;

    background: linear-gradient(
      180deg,
      #fff2e5 0%,
      rgba(255, 252, 245, 0) 100%
    );
    border-radius: 12px 12px 12px 12px;

    .pg2-box {
      position: relative;
      width: 213px;
      height: 64px;
      margin-top: 56px;
      left: 50%;
      transform: translateX(-50%);
      color: #701b07;
      font-size: 18px;
      font-weight: bolder;
      letter-spacing: 2px;
      line-height: 64px;
      text-align: center;
      .pg2 {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
    .text-box {
      width: 230px;
      height: 82px;
      background: #fff6ec;
      border-radius: 4px 4px 4px 4px;
      padding: 10px 16px;
      box-sizing: border-box;
      color: #d67600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 18px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
    .btn-box {
      width: 192px;
      height: 38px;
      background: linear-gradient(147deg, #ffbb00 0%, #ff8400 100%);
      border-radius: 19px;
      text-align: center;
      line-height: 38px;
      letter-spacing: 2px;
      color: #fff;
      font-size: 18px;
      font-weight: bolder;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 24px;
      cursor: pointer;
    }
  }
}
.tips-main2 {
  display: block;
  .tips-box-fa {
    top: 30px;
  }
}
</style>
